"use strict";

var _classCallCheck = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PendingOperation_1 = require("./PendingOperation");

var Resource_1 = require("./Resource");

var utils_1 = require("./utils");

var events_1 = require("events");

var Pool =
/*#__PURE__*/
function () {
  function Pool(opt) {
    _classCallCheck(this, Pool);

    this.destroyed = false;
    this.emitter = new events_1.EventEmitter();
    opt = opt || {};

    if (!opt.create) {
      throw new Error('Tarn: opt.create function most be provided');
    }

    if (!opt.destroy) {
      throw new Error('Tarn: opt.destroy function most be provided');
    }

    if (typeof opt.min !== 'number' || opt.min < 0 || opt.min !== Math.round(opt.min)) {
      throw new Error('Tarn: opt.min must be an integer >= 0');
    }

    if (typeof opt.max !== 'number' || opt.max <= 0 || opt.max !== Math.round(opt.max)) {
      throw new Error('Tarn: opt.max must be an integer > 0');
    }

    if (opt.min > opt.max) {
      throw new Error('Tarn: opt.max is smaller than opt.min');
    }

    if (!utils_1.checkOptionalTime(opt.acquireTimeoutMillis)) {
      throw new Error('Tarn: invalid opt.acquireTimeoutMillis ' + JSON.stringify(opt.acquireTimeoutMillis));
    }

    if (!utils_1.checkOptionalTime(opt.createTimeoutMillis)) {
      throw new Error('Tarn: invalid opt.createTimeoutMillis ' + JSON.stringify(opt.createTimeoutMillis));
    }

    if (!utils_1.checkOptionalTime(opt.destroyTimeoutMillis)) {
      throw new Error('Tarn: invalid opt.destroyTimeoutMillis ' + JSON.stringify(opt.destroyTimeoutMillis));
    }

    if (!utils_1.checkOptionalTime(opt.idleTimeoutMillis)) {
      throw new Error('Tarn: invalid opt.idleTimeoutMillis ' + JSON.stringify(opt.idleTimeoutMillis));
    }

    if (!utils_1.checkOptionalTime(opt.reapIntervalMillis)) {
      throw new Error('Tarn: invalid opt.reapIntervalMillis ' + JSON.stringify(opt.reapIntervalMillis));
    }

    if (!utils_1.checkOptionalTime(opt.createRetryIntervalMillis)) {
      throw new Error('Tarn: invalid opt.createRetryIntervalMillis ' + JSON.stringify(opt.createRetryIntervalMillis));
    }

    var allowedKeys = {
      create: true,
      validate: true,
      destroy: true,
      log: true,
      min: true,
      max: true,
      acquireTimeoutMillis: true,
      createTimeoutMillis: true,
      destroyTimeoutMillis: true,
      idleTimeoutMillis: true,
      reapIntervalMillis: true,
      createRetryIntervalMillis: true,
      propagateCreateError: true
    };

    for (var _i = 0, _Object$keys = Object.keys(opt); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];

      if (!allowedKeys[key]) {
        throw new Error("Tarn: unsupported option opt.".concat(key));
      }
    }

    this.creator = opt.create;
    this.destroyer = opt.destroy;
    this.validate = typeof opt.validate === 'function' ? opt.validate : function () {
      return true;
    };

    this.log = opt.log || function () {};

    this.acquireTimeoutMillis = opt.acquireTimeoutMillis || 30000;
    this.createTimeoutMillis = opt.createTimeoutMillis || 30000;
    this.destroyTimeoutMillis = opt.destroyTimeoutMillis || 5000;
    this.idleTimeoutMillis = opt.idleTimeoutMillis || 30000;
    this.reapIntervalMillis = opt.reapIntervalMillis || 1000;
    this.createRetryIntervalMillis = opt.createRetryIntervalMillis || 200;
    this.propagateCreateError = !!opt.propagateCreateError;
    this.min = opt.min;
    this.max = opt.max;
    this.used = [];
    this.free = [];
    this.pendingCreates = [];
    this.pendingAcquires = [];
    this.pendingDestroys = [];
    this.destroyed = false;
    this.interval = null;
    this.eventId = 1;
  }

  _createClass(Pool, [{
    key: "numUsed",
    value: function numUsed() {
      return this.used.length;
    }
  }, {
    key: "numFree",
    value: function numFree() {
      return this.free.length;
    }
  }, {
    key: "numPendingAcquires",
    value: function numPendingAcquires() {
      return this.pendingAcquires.length;
    }
  }, {
    key: "numPendingCreates",
    value: function numPendingCreates() {
      return this.pendingCreates.length;
    }
  }, {
    key: "acquire",
    value: function acquire() {
      var _this = this;

      var eventId = this.eventId++;

      this._executeEventHandlers('acquireRequest', eventId);

      var pendingAcquire = new PendingOperation_1.PendingOperation(this.acquireTimeoutMillis);
      this.pendingAcquires.push(pendingAcquire); // If the acquire fails for whatever reason
      // remove it from the pending queue.

      pendingAcquire.promise = pendingAcquire.promise.then(function (resource) {
        _this._executeEventHandlers('acquireSuccess', eventId, resource);

        return resource;
      }).catch(function (err) {
        _this._executeEventHandlers('acquireFail', eventId, err);

        remove(_this.pendingAcquires, pendingAcquire);
        return Promise.reject(err);
      });

      this._tryAcquireOrCreate();

      return pendingAcquire;
    }
  }, {
    key: "release",
    value: function release(resource) {
      this._executeEventHandlers('release', resource);

      for (var i = 0, l = this.used.length; i < l; ++i) {
        var used = this.used[i];

        if (used.resource === resource) {
          this.used.splice(i, 1);
          this.free.push(used.resolve());

          this._tryAcquireOrCreate();

          return true;
        }
      }

      return false;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return [this.numFree(), this.numUsed(), this.numPendingAcquires(), this.numPendingCreates()].reduce(function (total, value) {
        return total + value;
      }) === 0;
    }
  }, {
    key: "check",
    value: function check() {
      var _this2 = this;

      var timestamp = utils_1.now();
      var newFree = [];
      var minKeep = this.min - this.used.length;
      var maxDestroy = this.free.length - minKeep;
      var numDestroyed = 0;
      this.free.forEach(function (free) {
        if (utils_1.duration(timestamp, free.timestamp) >= _this2.idleTimeoutMillis && numDestroyed < maxDestroy) {
          numDestroyed++;

          _this2._destroy(free.resource);
        } else {
          newFree.push(free);
        }
      });
      this.free = newFree; // Pool is completely empty, stop reaping.
      // Next .acquire will start reaping interval again.

      if (this.isEmpty()) {
        this._stopReaping();
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this3 = this;

      var eventId = this.eventId++;

      this._executeEventHandlers('poolDestroyRequest', eventId);

      this._stopReaping();

      this.destroyed = true; // First wait for all the pending creates get ready.

      return utils_1.reflect(Promise.all(this.pendingCreates.map(function (create) {
        return utils_1.reflect(create.promise);
      })).then(function () {
        // Wait for all the used resources to be freed.
        return Promise.all(_this3.used.map(function (used) {
          return utils_1.reflect(used.promise);
        }));
      }).then(function () {
        // Abort all pending acquires.
        return Promise.all(_this3.pendingAcquires.map(function (acquire) {
          acquire.abort();
          return utils_1.reflect(acquire.promise);
        }));
      }).then(function () {
        // Now we can destroy all the freed resources.
        return Promise.all(_this3.free.map(function (free) {
          return utils_1.reflect(_this3._destroy(free.resource));
        }));
      }).then(function () {
        // Also wait rest of the pending destroys to finish
        return Promise.all(_this3.pendingDestroys.map(function (pd) {
          return pd.promise;
        }));
      }).then(function () {
        _this3.free = [];
        _this3.pendingAcquires = [];
      })).then(function (res) {
        _this3._executeEventHandlers('poolDestroySuccess', eventId);

        _this3.emitter.removeAllListeners();

        return res;
      });
    }
  }, {
    key: "on",
    value: function on(event, listener) {
      this.emitter.on(event, listener);
    }
  }, {
    key: "removeListener",
    value: function removeListener(event, listener) {
      this.emitter.removeListener(event, listener);
    }
  }, {
    key: "removeAllListeners",
    value: function removeAllListeners(event) {
      this.emitter.removeAllListeners(event);
    }
  }, {
    key: "_tryAcquireOrCreate",
    value: function _tryAcquireOrCreate() {
      if (this.destroyed) {
        return;
      }

      if (this._hasFreeResources()) {
        this._doAcquire();
      } else if (this._shouldCreateMoreResources()) {
        this._doCreate();
      }
    }
  }, {
    key: "_hasFreeResources",
    value: function _hasFreeResources() {
      return this.free.length > 0;
    }
  }, {
    key: "_doAcquire",
    value: function _doAcquire() {
      var didDestroyResources = false;

      while (this._canAcquire()) {
        var pendingAcquire = this.pendingAcquires[0];
        var free = this.free[this.free.length - 1];

        if (!this._validateResource(free.resource)) {
          this.free.pop();

          this._destroy(free.resource);

          didDestroyResources = true;
          continue;
        }

        this.pendingAcquires.shift();
        this.free.pop();
        this.used.push(free.resolve()); //At least one active resource, start reaping

        this._startReaping();

        pendingAcquire.resolve(free.resource);
      } // If we destroyed invalid resources, we may need to create new ones.


      if (didDestroyResources) {
        this._tryAcquireOrCreate();
      }
    }
  }, {
    key: "_canAcquire",
    value: function _canAcquire() {
      return this.free.length > 0 && this.pendingAcquires.length > 0;
    }
  }, {
    key: "_validateResource",
    value: function _validateResource(resource) {
      try {
        return !!this.validate(resource);
      } catch (err) {
        // There's nothing we can do here but log the error. This would otherwise
        // leak out as an unhandled exception.
        this.log('Tarn: resource validator threw an exception ' + err.stack, 'warn');
        return false;
      }
    }
  }, {
    key: "_shouldCreateMoreResources",
    value: function _shouldCreateMoreResources() {
      return this.used.length + this.pendingCreates.length < this.max && this.pendingCreates.length < this.pendingAcquires.length;
    }
  }, {
    key: "_doCreate",
    value: function _doCreate() {
      var _this4 = this;

      var pendingAcquiresBeforeCreate = this.pendingAcquires.slice();

      var pendingCreate = this._create();

      pendingCreate.promise.then(function () {
        // Not returned on purpose.
        _this4._tryAcquireOrCreate();

        return null;
      }).catch(function (err) {
        if (_this4.propagateCreateError && _this4.pendingAcquires.length !== 0) {
          // If propagateCreateError is true, we don't retry the create
          // but reject the first pending acquire immediately. Intentionally
          // use `this.pendingAcquires` instead of `pendingAcquiresBeforeCreate`
          // in case some acquires in pendingAcquiresBeforeCreate have already
          // been resolved.
          _this4.pendingAcquires[0].reject(err);
        } // Save the create error to all pending acquires so that we can use it
        // as the error to reject the acquire if it times out.


        pendingAcquiresBeforeCreate.forEach(function (pendingAcquire) {
          pendingAcquire.possibleTimeoutCause = err;
        }); // Not returned on purpose.

        utils_1.delay(_this4.createRetryIntervalMillis).then(function () {
          return _this4._tryAcquireOrCreate();
        });
      });
    }
  }, {
    key: "_create",
    value: function _create() {
      var _this5 = this;

      var eventId = this.eventId++;

      this._executeEventHandlers('createRequest', eventId);

      var pendingCreate = new PendingOperation_1.PendingOperation(this.createTimeoutMillis);
      this.pendingCreates.push(pendingCreate);
      callbackOrPromise(this.creator).then(function (resource) {
        remove(_this5.pendingCreates, pendingCreate);

        _this5.free.push(new Resource_1.Resource(resource)); // Not returned on purpose.


        pendingCreate.resolve(resource);

        _this5._executeEventHandlers('createSuccess', eventId, resource);

        return null;
      }).catch(function (err) {
        remove(_this5.pendingCreates, pendingCreate); // Not returned on purpose.

        pendingCreate.reject(err);

        _this5._executeEventHandlers('createFail', eventId, err);

        return null;
      });
      return pendingCreate;
    }
  }, {
    key: "_destroy",
    value: function _destroy(resource) {
      var _this6 = this;

      var eventId = this.eventId++;

      this._executeEventHandlers('destroyRequest', eventId, resource); // this.destroyer can be both synchronous and asynchronous.
      // so we wrap it to promise to get all exceptions through same pipeline


      var pendingDestroy = new PendingOperation_1.PendingOperation(this.destroyTimeoutMillis);
      var retVal = Promise.resolve().then(function () {
        return _this6.destroyer(resource);
      });
      retVal.then(function () {
        pendingDestroy.resolve(resource);
      }).catch(function (err) {
        pendingDestroy.reject(err);
      });
      this.pendingDestroys.push(pendingDestroy); // In case of an error there's nothing we can do here but log it.

      return pendingDestroy.promise.then(function (res) {
        _this6._executeEventHandlers('destroySuccess', eventId, resource);

        return res;
      }).catch(function (err) {
        return _this6._logDestroyerError(eventId, resource, err);
      }).then(function (res) {
        var index = _this6.pendingDestroys.findIndex(function (pd) {
          return pd === pendingDestroy;
        });

        _this6.pendingDestroys.splice(index, 1);

        return res;
      });
    }
  }, {
    key: "_logDestroyerError",
    value: function _logDestroyerError(eventId, resource, err) {
      this._executeEventHandlers('destroyFail', eventId, resource, err);

      this.log('Tarn: resource destroyer threw an exception ' + err.stack, 'warn');
    }
  }, {
    key: "_startReaping",
    value: function _startReaping() {
      var _this7 = this;

      if (!this.interval) {
        this._executeEventHandlers('startReaping');

        this.interval = setInterval(function () {
          return _this7.check();
        }, this.reapIntervalMillis);
      }
    }
  }, {
    key: "_stopReaping",
    value: function _stopReaping() {
      if (this.interval !== null) {
        this._executeEventHandlers('stopReaping');

        clearInterval(this.interval);
      }

      this.interval = null;
    }
  }, {
    key: "_executeEventHandlers",
    value: function _executeEventHandlers(eventName) {
      var _this8 = this;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var listeners = this.emitter.listeners(eventName); // just calling .emit() would stop running rest of the listeners if one them fails

      listeners.forEach(function (listener) {
        try {
          listener.apply(void 0, args);
        } catch (err) {
          // There's nothing we can do here but log the error. This would otherwise
          // leak out as an unhandled exception.
          _this8.log("Tarn: event handler \"".concat(eventName, "\" threw an exception ").concat(err.stack), 'warn');
        }
      });
    }
  }]);

  return Pool;
}();

exports.Pool = Pool;

function remove(arr, item) {
  var idx = arr.indexOf(item);

  if (idx === -1) {
    return false;
  } else {
    arr.splice(idx, 1);
    return true;
  }
}

function callbackOrPromise(func) {
  return new Promise(function (resolve, reject) {
    var callback = function callback(err, resource) {
      if (err) {
        reject(err);
      } else {
        resolve(resource);
      }
    };

    utils_1.tryPromise(function () {
      return func(callback);
    }).then(function (res) {
      // If the result is falsy, we assume that the callback will
      // be called instead of interpreting the falsy value as a
      // result value.
      if (res) {
        resolve(res);
      }
    }).catch(function (err) {
      reject(err);
    });
  });
}